import { ExpressionGroupsState, ApiConditions } from '../types';
import { generateId } from './generateId';

export const transformConditionsToExpressionGroupsState = (
  conditions: ApiConditions | undefined
): ExpressionGroupsState | undefined => {
  if (!conditions) {
    return undefined;
  }

  // First, check if we already have a valid ExpressionGroupsState structure
  if (conditions.expressionsStructure && conditions.expressionsStructure.groups && conditions.expressionsStructure.operator) {
    return conditions.expressionsStructure;
  }

  // If we have expressions array, build the structure from it
  if (conditions.expressions && Array.isArray(conditions.expressions) && conditions.expressions.length > 0) {
    const groups: { [groupId: string]: any } = {};
    
    conditions.expressions.forEach((expr: any, index: number) => {
      // Handle missing or undefined IDs by generating them
      const groupId = expr.groupId || `group-${index}`;
      const expressionId = expr.id || `expr-${index}`;
      
      // Try different possible field property names
      const fieldName = expr.field || expr.fieldIdentifier || expr.fieldName || expr.column || expr.property || 'unknown';
      
      if (!groups[groupId]) {
        groups[groupId] = {
          operator: 'AND',
          expressions: {}
        };
      }
      
      groups[groupId].expressions[expressionId] = {
        id: expressionId,
        field: { 
          identifier: fieldName, 
          label: fieldName.charAt(0).toUpperCase() + fieldName.slice(1), // Capitalize first letter
          fieldType: expr.fieldType || 'text',
          operators: ['equals', 'not_equals', 'greater_than', 'less_than'] // Provide default operators
        },
        operator: expr.operator === 'eq' ? 'equals' : (expr.operator || 'equals'), // Map operators
        value: Array.isArray(expr.value) ? expr.value : [expr.value], // Ensure array
        isCompleted: true
      };
    });
    
    const result = {
      groups,
      operator: 'OR' as const
    };
    
    return result;
  }

  // Last fallback: check if conditions is already the structure we need
  if ((conditions as any).groups && typeof (conditions as any).groups === 'object') {
    return {
      groups: (conditions as any).groups,
      operator: (conditions as any).operator || 'OR'
    };
  }

  return undefined;
}; 